import api from '../../api/api';
import * as ACTIONS from '../actionTypes';
import * as MUTATION from '../mutationTypes';
import {cacheAction} from 'vuex-cache';

export default {
  [ACTIONS.PAYMENT_PREPARE]: async (state, params) => {
    return await api.paymentApi.prepare(params);
  },
  [ACTIONS.PAYMENT_PAY]: async (state, params) => {
    return await api.paymentApi.pay(params);
  },
  [ACTIONS.GET_PACKAGES_CACHED]: cacheAction(({cache, commit}, params) => {
    cache
        .dispatch(ACTIONS.GET_PACKAGES, params)
        .then((packages) => {
          commit(MUTATION.UPDATE_PACKAGES_LIST, packages);
        });
  }),
  [ACTIONS.GET_PACKAGES]: async ({commit}, params) => {
    const packages = await api.paymentApi.packages(params);
    commit(MUTATION.UPDATE_PACKAGES_LIST, packages);
    return packages;
  },
  [ACTIONS.GET_SUBSCRIPTIONS_CACHED]: cacheAction(({cache, commit}, params) => {
    cache.dispatch(ACTIONS.GET_SUBSCRIPTIONS, params)
        .then((packages) => {
          commit(MUTATION.UPDATE_SUBSCRIPTIONS_LIST, packages);
        });
  }),
  [ACTIONS.GET_SUBSCRIPTIONS]: async ({commit}, params) => {
    const subscriptions = await api.paymentApi.subscriptions(params);
    commit(MUTATION.UPDATE_SUBSCRIPTIONS_LIST, subscriptions);
    return subscriptions;
  },
  [ACTIONS.GET_EVENT_PACKAGES]: async ({commit}, params) => {
    return await api.paymentApi.packages(params);
  },
  [ACTIONS.GET_PACKAGE]: async (state, params) => {
    return await api.paymentApi.package(params);
  },
  [ACTIONS.GET_SUBSCRIPTION]: async (state, params) => {
    return await api.paymentApi.subscription(params);
  },
  [ACTIONS.GET_ORDERS]: async ({commit}, params) => {
    const orders = await api.paymentApi.orders(params);
    commit(MUTATION.UPDATE_ORDERS_LIST, orders);
    return orders.data;
  },
  [ACTIONS.GET_ORDER_BY_ID]: async (_, {order_id: orderId} = {}) => {
    if (!orderId) return false;
    return await api.paymentApi.orderById({orderId});
  },
  [ACTIONS.APPLY_COUPON]: async (_, params) => {
    return await api.paymentApi.applyCoupon(params);
  },
};
